import { apiService } from "./apiService";

export function fetchGiftCardCategories(data) {
  return apiService({
    method: "POST",
    url: "/api/giftcard/categories",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function fetchGiftCards(data) {
  return apiService({
    method: "POST",
    url: "/api/giftcard/cards",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateGiftCard(cardId, data) {
  return apiService({
    method: "PATCH",
    url: `/api/giftcard/cards/${cardId}`,
    data: data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateGiftCategoryStatus(categoryId, data) {
  return apiService({
    method: "PATCH",
    url: `/api/giftcard/categories/${categoryId}/status`,
    data: data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateGiftCardRates() {
  return apiService({
    method: "GET",
    url: `/api/giftcard/rates`,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getGiftCardTransaction(data) {
  return apiService({
    method: "POST",
    url: "/api/giftcard/cardTransaction",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getGiftCardTransactionById(id) {
  return apiService({
    method: "GET",
    url: "/api/giftcard/cardTransaction/" + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateGiftCardTransaction(id, data) {
  return apiService({
    method: "POST",
    url: "/api/giftcard/transaction/" + id + "/process",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}
